import React from "react";
import { createRoot } from "react-dom/client";
import Wrapper from "./components/Wrapper";
import { Provider as JotaiProvider } from "jotai";
import { StyleSmetaComponents } from "./components/MainPage/GlobalStyled";
import ModalPortal from "./components/MainPage/Module/ModalPortal";
import { ThemeProvider } from "./provider/ThemeProvider";
import "./static/scss/CheckBox.scss";
import "./static/scss/DocTabs.scss";
import "./static/scss/DropList.scss";
import "./static/scss/Grid.scss";
import "./static/scss/ModalPortal.scss";
import "./static/scss/ResizeGrid.scss";
import "./static/scss/ResizePanel.scss";
import "./static/scss/SplitterLocal.scss";
import "./static/scss/TextField.scss";
import "./static/scss/Tree.scss";
import "./static/scss/Lk.scss";
import "./static/scss/snow.min.css";
import "./static/js/Snow";
import "./components/MainPage/StyleSmartWebcomponents.css";
import { ErrorBoundary } from "react-error-boundary";
import fallbackRender from "./components/ErrorFallBack";
import { smetaStore } from "./atoms";
import "react-toastify/dist/ReactToastify.css";
import { AppThemeRoot } from "./theme/AppThemeRoot";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <StyleSmetaComponents />
    <ErrorBoundary fallbackRender={fallbackRender}>
      <JotaiProvider store={smetaStore}>
        <AppThemeRoot>
          <Wrapper />
          <ThemeProvider>
            <ModalPortal />
          </ThemeProvider>
        </AppThemeRoot>
      </JotaiProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
